import React from 'react'

import { IconSVGProps } from '@sidecar-components/atoms/Icon/Icon.types'

export const Lab = ({
  className,
  pathClass,
  size = 6,
  ...rest
}: IconSVGProps) => (
  <svg
    aria-label="lab icon"
    className={`h-${size} w-${size} ${className}`}
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      className={pathClass}
      fillRule="evenodd"
      clipRule="evenodd"
      d="M18.9999 3H16.4999V8.61131L22.4999 20.5C22.758 20.9646 23.3645 22.2709 22.9999 23C22.5589 23.8818 21.5314 24 20.9999 24H2.99993C2.46845 24 1.46947 23.939 0.999967 23C0.553744 22.1076 1.09657 21.187 1.40198 20.669C1.43879 20.6066 1.47216 20.55 1.49992 20.5L7.49995 8.61131V3H4.99994V0L18.9999 0V3ZM10.4999 3H13.4999V9C13.4999 9.25492 13.5649 9.50563 13.6887 9.72846L16.0618 14H7.9381L10.3112 9.72847C10.435 9.50563 10.4999 9.25492 10.4999 9V3Z"
    />
  </svg>
)
